import { FieldExtensionComponentProps, useTemplateSecrets } from "@backstage/plugin-scaffolder-react";
import { useOauthSignIn } from '../../hooks/useOauthSignIn';
  import {
	Progress,
	ErrorPanel,
  } from '@backstage/core-components';
import { Box, Typography, Button } from '@material-ui/core';
import { AzureDevOpsOauthContext } from '../../hooks/useOauthContext';
import { useEffect } from "react";

export const AzureDevOpsOauthWrapper = ({
	...props
}: FieldExtensionComponentProps<string, { organization: string, title?: string, message?: string }> & {
    scopes: string[]
	tokenSecretName?: string;
}) => {
	const { setSecrets } = useTemplateSecrets();
	const { token, loading, error, showSignInModal, isSignedIn } = useOauthSignIn({
		scopes: (props.scopes ?? []),
	});

	useEffect(() => {
		if (props.tokenSecretName) {
			setSecrets({ [props.tokenSecretName]: token });
		}
	}, [token, props.tokenSecretName]);

	if (loading && !isSignedIn) {
		return <Progress />;
	}

	if (error) {
		return <ErrorPanel error={error} />;
	}

	if (!isSignedIn || !token) {
		return (
			<Box height="100%" width="100%">
				<Box>
					<Typography variant="body2">
						<b>{props.uiSchema['ui:options']?.title ?? props.name}</b>
					</Typography>
				</Box>
				<Box display="flex">
					<Box paddingRight={1}>
						<Typography>
							{props.uiSchema['ui:options']?.message ?? 'This input requires authentication with Azure DevOps.'}
						</Typography>
					</Box>
					<Box>
						<Button
							variant="outlined"
							color="primary"
							onClick={showSignInModal}
						>
							Sign in
						</Button>
					</Box>
				</Box>
			</Box>
		);
	}

	return (
        <AzureDevOpsOauthContext.Provider value={{ token }}>
            {props.children}
        </AzureDevOpsOauthContext.Provider>
	);
};